<template>
  <div class="main_box">
    <div class="body_title">
      <h2>{{ $t('menu.businessData') }}</h2>
      <div class="home_select">
        <el-select class="select_box" v-model="times" @change="changeTime">
          <el-option v-for="item in all_times" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div>
      <div class="small_title w80 flex flex_layout_between">
        <div>{{ $t('enum.orderData') }}</div>
      </div>
      <div class="flex box_blue">
        <div class="blue_box">
          <div class="blue_txt">
            <div>{{ $t('enum.orderTotal') }}</div>
            <div>USD {{ items.TotalPriceUSD ? items.TotalPriceUSD : 0 }}</div>
            <!-- <div>Compare to last week<span class="arrow_rise"></span>10%</div> -->
          </div>
        </div>
        <div class="blue_box">
          <div class="blue_txt">
            <div>{{ $t('enum.orderAmount') }}</div>
            <div>{{ items.OrdersCount ? items.OrdersCount : 0 }}</div>
            <!-- <div>Compare to last week<span class="arrow_decline"></span>10%</div> -->
          </div>
        </div>
      </div>
      <div class="small_title">{{ $t('enum.itemData') }}</div>
      <div class="flex box_blue">
        <div class="blue_box">
          <div class="blue_txt">
            <div>{{ $t('enum.itemListed') }}</div>
            <div>{{ items.NewListingCount ? items.NewListingCount : 0 }}</div>
            <!-- <div>Compare to last week<span class="arrow_rise"></span>10%</div> -->
          </div>
        </div>
        <div class="blue_box">
          <div class="blue_txt">
            <div>{{ $t('enum.itemSold') }}</div>
            <div>{{ items.SoldCount ? items.SoldCount : 0 }}</div>
            <!-- <div> Compare to last week<span class="arrow_decline"></span>10%</div> -->
          </div>
        </div>
        <div class="blue_box">
          <div class="blue_txt">
            <div>{{ $t('enum.itemUnsold') }}</div>
            <div>{{ items.UnSoldCount ? items.UnSoldCount : 0 }}</div>
            <!-- <div>Compare to last week<span class="arrow_rise"></span>10%</div> -->
          </div>
        </div>
        <!-- <div class="blue_box">
            <div class="blue_txt">
              <div>Add to Watchlist</div>
              <div>{{ Watchlist }}</div>
              <div>Compare to last week<span class="arrow_rise"></span>10%</div>
            </div>
          </div> -->
      </div>

      <div class="btn_box">
        <div class="data_btn_box">
          <div @click="isDate(1)" :class="[canDownload ? '' : 'disable']">{{ $t('button.exportOrderList') }}</div>
          <div @click="isDate(2)" :class="[canDownload ? '' : 'disable']">{{ $t('button.exportPayoutList') }}</div>
        </div>
        <div class="down_tips" v-if="!canDownload">{{ $t('tips.canDownTime') }}</div>
      </div>

    </div>

    <el-dialog :title="dialogTitle + ' (PST)'" :visible.sync="dialogVisible" :close-on-click-modal="false" style="margin-top: 20vh;" width="480px">
      <div class="dialog_box">
        <el-date-picker class="dialog_date" v-model="date" @change="datePickerChange" type="daterange" start-placeholder="StartTime" end-placeholder="EndTime" :picker-options="pickeroptions" :default-value="timeDefaultShow">
        </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <div class="tips" v-if="tips">{{ tips }}</div> -->
        <el-button @click="dialogVisible = false">{{ $t('button.cancel') }}</el-button>
        <!-- <el-button type="primary" @click="dialogVisible = false">
            Save
          </el-button> -->
        <span v-if="canDownload" :class="['data_btn', 'data_btn_download']" @click="download()">
          {{ $t('button.output') }}
        </span>
        <span v-else :class="['data_btn', 'data_btn_download', 'disable']">{{ $t('button.output') }}</span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      dialogTitle: this.$t('enum.paymentTime'),
      dialogVisible: false,
      times: this.$t('enum.lastDays', [30]),
      all_times: [{ value: 7, label: this.$t('enum.lastDays', [7]) }, { value: 30, label: this.$t('enum.lastDays', [30]) }],
      items: {},
      timeDefaultShow: new Date().setMonth(new Date().getMonth() - 1),
      date: [],//默认时间范围
      startTime: "",
      endTime: "",
      tips: "",//是否可以下载提示
      canDownload: false,//是否可以下载（有开始时间和结束时间）
      OrderReportType: 1,
      pickeroptions: {
        // onPick：是选中日期时的回调函数，可以在这里对选中的日期进行处{maxDate：后选中日期；minDate：第一个选中的日期}
        onPick: ({ maxDate, minDate }) => {
          this.startDate = minDate && minDate.getTime();
          if (maxDate) {
            // 选中后一个时，要把第一个的赋值清空
            this.startDate = ''
          }
        },
        disabledDate: (time) => {
          const today = this.$store.state.toDay;//今天
          let xxx = this.startDate ? (today - this.startDate) / (24 * 60 * 60 * 1000) - 1 : 0;//起始时间距当天日期间隔天数
          xxx = xxx >= 0 ? Math.abs(xxx) : 0;
          // console.log("today", parseInt(today), "this.startDate", this.startDate, "xxx", xxx);
          const month = 30 * 24 * 60 * 60 * 1000 // 设定日期范围
          const minTime = this.startDate - month
          const maxTime = xxx >= 0 && xxx < 30 ? this.startDate + xxx * 24 * 60 * 60 * 1000 : this.startDate + month;
          if (this.startDate) {
            // 选中第一个时，前后30天[-30,30]共60天可选选择，超出的不可选，这里的天数按自己喜欢设定
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          else {
            // 不选任何日期执行下面的代码
            return time.getTime() >= today;//time.getTime() > Date.now();//Date.now() - 8.64e6;
          }
        }
      }
    };
  },
  watch: {
    startTime: {
      handler(newVal, oldVal) {
        let canDownload = this.startTime && this.endTime ? true : false
        // this.canDownload = canDownload;
        if (!canDownload) {
          this.canDownload = false;
        }
      },
      deep: true,
    }
  },
  mounted() {
    var that = this;
    // console.log("*****", this.$store.state.mGuess);
    that.getSEtime(30)//默认获取30Days
  },
  methods: {
    getData(api, params) {
      var that = this;
      that.$get(api, params).then((res) => {
        if (res.result) {
          switch (api) {
            case "GetSellerData":
              console.log("GetSellerData", res);
              let _data = res.data;
              that.items = _data;
              break;
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    ExportTimeCheck() {
      //检查是否可以下载
      var that = this;
      that.canDownload = false;
      var _UserInfo = that.$store.state.UserInfo;
      var params = `?MemberID=${_UserInfo.MappingUserId}&operator_id=${_UserInfo.MappingUserId}&token=${_UserInfo.ChineseToken}&StartDate=${that.startTime}&EndDate=${that.endTime}&OrderReportType=${that.OrderReportType}`;
      that.$get('ExportTimeCheck', params).then((res) => {
        // console.log("**ExportTimeCheck***", res);
        if (res.result) {
          that.canDownload = true;
        } else {
          that.canDownload = false;
          that.tips = res.msg ? res.msg : "";
        }
      }).catch((err) => {
        // console.log(err);
        that.tips = res.msg ? res.msg : "";
        that.canDownload = false;
      });
    },
    download() {
      var that = this;
      var _UserInfo = that.$store.state.UserInfo;
      var params = `?MemberID=${_UserInfo.MappingUserId}&operator_id=${_UserInfo.MappingUserId}&token=${_UserInfo.ChineseToken}&StartDate=${that.startTime}&EndDate=${that.endTime}&OrderReportType=${that.OrderReportType}`;

      var link = `${that.$store.state.ExportOrderReport}${params}`;
      console.log(link);
      window.location.href = link;
      // window.open(link);
    },
    changeTime(e) {
      // console.log("changeTime", e);
      this.getSEtime(e);
    },
    datePickerChange(e) {
      var that = this;
      let _date = that.date;
      if (_date && _date.length) {
        let startTime = that.$store.getters.getTime(
          _date[0],
          8,
          "cmtNull",
          "YYYY-MM-DD"
        );
        let endTime = that.$store.getters.getTime(
          _date[1],
          8,
          "cmtNull",
          "YYYY-MM-DD"
        );
        that.startTime = startTime;
        that.endTime = endTime;
        that.ExportTimeCheck();//检查是否可以下载
        // console.log("startTime-endTime:", startTime, endTime);
      } else {
        that.startTime = '';
        that.endTime = '';
      }
    },
    getSEtime(e, type) {
      var that = this;
      //获取时间
      if (!e) { e = 7 }
      //开始时间
      let startTime = that.$store.getters.timeCount(new Date(), e, 'd');
      startTime = that.$store.getters.getTime(
        startTime,
        8,
        "cmtNull",
        "YYYY-MM-DD"
      );
      //结束时间
      let endTime = that.$store.getters.timeCount(new Date(), 1, 'd');
      endTime = that.$store.getters.getTime(
        endTime,
        8,
        "cmtNull",
        "YYYY-MM-DD"
      );
      that.startTime = startTime;
      that.endTime = endTime;
      that.date = [new Date(startTime), new Date(endTime)];
      // console.log("startTime-endTime", startTime, endTime, that.date)
      that.getData('GetSellerData', `?StartDate=${startTime}&EndDate=${endTime}`);//卖家日销售统计
      that.ExportTimeCheck();//检查是否可以下载
    },
    MsgTabs(val) {
      let that = this;
      that.msgTabs = val;
    },
    isDate(val) {
      if (this.canDownload) {
        this.dialogTitle = val != 2 ? this.$t('enum.orderTime') : this.$t('enum.paymentTime');
        this.OrderReportType = val;
        this.dialogVisible = true;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialog_date>.el-dialog {
  margin-top: 22vh;
}

.home_select {
  display: flex;
}

.home_select span {
  font-weight: bold;
  margin-right: 10px;
}

.select_box {
  width: 132px;
}

.box_blue {
  width: 100%;
}

.blue_box {
  min-width: 186px;
  padding: 12px;
  margin-right: 20px;
}

.box_blue .blue_box:nth-child(4) {
  margin-right: 0px;
}

.blue_txt div:nth-child(2) {
  color: #5f6dae;
  font-size: 32px;
  font-weight: bold;
  padding: 12px 0;
}

.blue_txt div:nth-child(3) span {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 0 4px;
}

.dialog_box {
  width: 100%;
}
.down_tips{
  font-size: 14px;
  color: #f40;
  margin-top: 20px;
}
.btn_box{
  margin-top: 60px;
}

.data_btn_box,
.dialog-footer {
  display: flex;
}

.dialog-footer {
  margin-top: 0;
  justify-content: flex-end;
}

.data_btn_box div,
.data_btn {
  display: block;
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  background: #5f6dae;
  border-radius: 3px;
  margin-right: 20px;
  cursor: pointer;
}

.data_btn_download {
  margin: 0 0 0 20px;
}

.data_btn_download.disable,
.data_btn_box .disable {
  background: #999;
  cursor: no-drop;
}

.dialog_box {
  text-align: center;
}

.dialog_date {
  width: 93%;
  margin: 0 auto;
}

.arrow_rise {
  background: url(../../../static/images/icon_arrow_rise.png);
}

.arrow_decline {
  background: url(../../../static/images/icon_arrow_decline.png);
}

.tips {
  width: auto;
  flex: 1;
  color: #f40;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/data/index.vue